package fr.frux.shared.dto

import kotlinx.serialization.Serializable

/** Type de trait d'un arbre. */
@Serializable
enum class TreeTraitKindDto { ACCESS_DIFFICULT, DELICIOUS }

/** Résumé d'un trait avec compteur et indicateur personnel. */
@Serializable
data class TreeTraitSummary(
    val kind: TreeTraitKindDto,
    val count: Int,
    val mine: Boolean,
)

/** Requête d'ajout d'un trait à un arbre. */
@Serializable
data class AddTreeTraitRequest(
    val kind: TreeTraitKindDto,
)
